import axios from "../customize_axios"

export const getBannerActive = async () => {
    try {
        const response = await axios.get(`api/banners/is-active`)
        return response.data
    } 
    catch (error) {
        console.log("getBannerActive", error.response ? error.response.data : error.message)
        return []
    }
}